// Application types

// values are prefixed so they don't trigger the referral reducer, which uses the same key names
const REVENUE_SETTINGS = {
  LOADING_REFERRALS: "REVENUE_SETTINGS_LOADING",
  ALL_REFERRALS: "REVENUE_SETTINGS_ALL",
  SEARCHING: "REVENUE_SETTINGS_SEARCHING",
  SEARCH_REFERRALS: "REVENUE_SETTINGS_SEARCH",
  GET_MY_REFERRALS: "REVENUE_SETTINGS_GET_MY",
  REVENUE_SETTINGS_FILTERING: "REVENUE_SETTINGS_FILTERING",
  REVENUE_SETTINGS_FILTER: "REVENUE_SETTINGS_FILTER",
  EDIT_REFERRALS: "REVENUE_SETTINGS_EDIT",
  DOWNLOADING: "REVENUE_SETTINGS_DOWNLOADING",
};

export default REVENUE_SETTINGS;
